import { useNavigate } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';

import formatPhoneNumber from '../../../utils/formatPhoneNumber';
import { IncomingInfoProps, IncomingInfoRowProps } from '../types';
import IncomingInfoRow from './IncomingInfoRow';
import { Button } from '../../../lib/button';

const IncomingInfo: React.FC<IncomingInfoProps> = ({ phone, personName }) => {
    const navigate = useNavigate();

    const rows: IncomingInfoRowProps['rows'] = [
        { label: 'Case status', val: 'Status' },
        { label: formatPhoneNumber(phone) },
        { label: 'Last contact', val: '4 days ago' },
        { label: 'Case created', val: '24 days ago' },
        { label: 'Pharma group', val: 'Suboxone' }
    ];
    /**
     *
     * TODO: use data from backend for rows and handleOpenCase (next task)
     *
     */
    const handleOpenCase = () => navigate(`/case-board/183593/notes`);

    return (
        <>
            <div className="py-10">
                <PhoneCall className="h-20 w-20 m-auto" />
            </div>
            {personName && (
                <p className="py-6 text-lg font-bold">
                    {personName} <span className="text-gray-400">is calling...</span>
                </p>
            )}
            <div className="flex justify-between items-center">
                <IncomingInfoRow rows={rows} />
                <Button variant="outline-dark" className="px-2" onClick={handleOpenCase}>
                    Open case
                </Button>
            </div>
        </>
    );
};
export default IncomingInfo;
